import styled from "@emotion/styled";
import { motion } from "motion/react";
import type { ReactNode } from "react";

import { FONT_WEIGHT_NORMAL, PAGE_SIDE_PADDING, withDataTest } from "../utilities";

const StyledPageLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;

  width: 100%;
  height: 100%;

  background-color: ${({ theme }) => theme.surfaceBack_1};

  overflow: hidden;
`;

export const PageLayout = withDataTest(StyledPageLayout, "page-layout");

const StyledPageContentContainer = styled.div`
  height: 100%;
  overflow: hidden;
  padding: 0 ${PAGE_SIDE_PADDING}px;
`;

export const PageContentContainer = withDataTest(StyledPageContentContainer, "page-content-container");

const StyledPageContainer = styled.div`
  background: ${({ theme }) => theme.surfaceVariant};
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const PageContainer = withDataTest(StyledPageContainer, "page-container");

const StyledPageHeader = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.surfaceVariant};
  border-bottom: solid 1px ${({ theme }) => theme.outline};
  margin: 0 ${PAGE_SIDE_PADDING}px;
  h2 {
    font-size: 24px;
    font-weight: 500;
    margin: 0;
  }
  h4 {
    font-size: ${({ theme }) => theme.fontSizeLarge};
    font-weight: ${FONT_WEIGHT_NORMAL};
    margin: 10px 0 0;
    color: ${({ theme }) => theme.generalTextIconVariant};
  }
`;

export const PageHeader = withDataTest(StyledPageHeader, "header-container");

type PageHeaderTitleProps = {
  title: ReactNode;
  subTitle?: ReactNode;
};
export const PageHeaderTitle = ({ title, subTitle }: PageHeaderTitleProps) => (
  <motion.div
    initial={{ y: "-50%", opacity: 0.25 }}
    animate={{ y: "0", opacity: 1 }}
    transition={{ type: "spring", duration: 0.4, bounce: 0.1 }}
    style={{ margin: "25px 0" }}
  >
    <h2>{title}</h2>
    {subTitle && <h4>{subTitle}</h4>}
  </motion.div>
);

const StyledPageHeaderTabsContainer = styled.div`
  margin-bottom: -1px;
`;

export const PageHeaderTabsContainer = withDataTest(StyledPageHeaderTabsContainer, "page-header-tabs-container");
